import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'
import {
  PageHeader,
  Button,
  BUTTON_VARIANT_PRIMARY
} from 'mailup-web-components'
import { notifyParent } from 'Helpers/notifyParent'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import {
  formValidState,
  pageState
} from 'Pages/MessageCreate/recoil/state/page'
import { saveMessageCallback } from '../recoil/callbacks/callbacks'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  const saveMessage = useRecoilCallback(saveMessageCallback, [])
  const { pageType, response, warning, error, loading } = useRecoilValue(
    pageState
  )
  const isValidForm = useRecoilValue(formValidState)

  useEffect(() => {
    notifyParent('selectMenuItemReact', [
      'EmailMessageImportFromFile',
      redirectUrl
    ])
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Messages' }),
      'data-mu-test': 'breadcrumb-item__messages'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Email' }),
      'data-mu-test': 'breadcrumb-item__email'
    },
    {
      label: intl.formatMessage({ id: 'Load.Common.Create' }),
      'data-mu-test': 'breadcrumb-item__create',
      url: '#',
      onClick: () => history.push('/messages/email/new')
    },
    {
      label: intl.formatMessage({
        id:
          pageType === 'file'
            ? 'Load.EmailMessageImport.PageTitleFile'
            : 'Load.EmailMessageImport.PageTitleURL'
      }),
      'data-mu-test': 'breadcrumb-item__pageType'
    }
  ]

  const ControlsComponent = () =>
    !error ? (
      <Button
        kind={BUTTON_VARIANT_PRIMARY}
        disabled={!isValidForm || (response && warning)}
        data-mu-test={`new-message-from-${pageType}`}
        onClick={saveMessage}
      >
        {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
      </Button>
    ) : null

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      ControlsComponent={ControlsComponent}
      title={intl.formatMessage({ id: 'Load.Common.Create' })}
      loading={loading}
    />
  )
}

export default Header
